import { useEffect, useRef, useState, useCallback } from "react";
import { API_URL } from "../../config";
import NewsCard from "./NewsCard";
import NewsModalViewer from "./NewsModalViewer";
import "./news.css";
import { useTranslation } from "../../shared/LanguageContext";

export default function NewsCarousel() {
    const [items, setItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [current, setCurrent] = useState(null);
    const scrollerRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        fetch(`${API_URL}/news`)
            .then(res => res.json())
            .then((data) => {
                if (Array.isArray(data)) setItems(data);
            })
            .catch(console.error);
    }, []);

    const scrollBy = (dir) => {
        const el = scrollerRef.current;
        if (!el) return;
        // Крутим ровно на 100% ширины видимой области, что соответствует одному слайду
        el.scrollBy({ left: dir * el.clientWidth, behavior: "smooth" });
    };

    const handleRead = useCallback((item) => {
        if (item.articleType === "external" && item.articleUrl) {
            window.open(item.articleUrl, "_blank", "noopener,noreferrer");
        } else {
            setCurrent(item);
            setModalOpen(true);
        }
    }, []);

    return (
        <section className="news-carousel-section">
            <div className="news-carousel-head">
                <h1>{t("news_title")}</h1>
                <div className="news-carousel-ctrls">
                    <button onClick={() => scrollBy(-1)} aria-label="prev" className="nc-btn">‹</button>
                    <button onClick={() => scrollBy(1)} aria-label="next" className="nc-btn">›</button>
                </div>
            </div>

            <div className="news-carousel-rail" ref={scrollerRef}>
                {items.length === 0 ? (
                    <div className="news-empty">{t("news_empty")}</div>
                ) : (
                    items.map((it) => (
                        <div className="news-slide" key={it.id}>
                            <NewsCard item={it} onRead={handleRead} />
                        </div>
                    ))
                )}
            </div>

            <NewsModalViewer open={modalOpen} onClose={() => setModalOpen(false)} item={current} />
        </section>
    );
}
